import useFetch from '../../../hooks/useFetch';
import { EndPoints } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';
import { useContext, useState } from 'react';
import { AppContext } from '../../../contexts/AppContext';
import { WarehouseQuoteDataForm } from '../../models/WareHouseQuote';
import { fetchDefaultHeaders } from '../shared/vars';

const useWarehouseQuoteService = () => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingCreate, setFetchingCreate] = useState(false);
    const [fetchingStore, setFetchingStore] = useState(false);
    const [fetchingEdit, setFetchingEdit] = useState(false);
    const [fetchingUpdate, setFetchingUpdate] = useState(false);
    const [fetchingShow, setFetchingShow] = useState(false);
    const [fetchingDelete, setFetchingDelete] = useState(false);

    const createWarehouseQuote = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.CREATE_WAREHOUSE_QUOTE,
            setFetching: setFetchingCreate
        });
    };

    const storeWarehouseQuote = (data: WarehouseQuoteDataForm, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.STORE_WAREHOUSE_QUOTE,
            body: data,
            setFetching: setFetchingStore
        });
    };

    const editWarehouseQuote = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.EDIT_WAREHOUSE_QUOTE.replace(':id', id.toString()),
            setFetching: setFetchingEdit
        });
    };

    const updateWarehouseQuote = (id: number, data: WarehouseQuoteDataForm, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.UPDATE_WAREHOUSE_QUOTE.replace(':id', id.toString()),
            body: data,
            setFetching: setFetchingUpdate
        });
    };

    const showWarehouseQuote = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.SHOW_WAREHOUSE_QUOTE.replace(':id', id.toString()),
            setFetching: setFetchingShow
        });
    };

    const deleteWarehouseQuote = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.DELETE_WAREHOUSE_QUOTE.replace(':id', id.toString()),
            setFetching: setFetchingDelete
        });
    };
    const getDocumentWarehouseQuote = (id: number, events: ServiceEvents = {}) => {
        if (showLoading) showLoading('download', 'descargando archivo...');
        fetch(EndPoints.WAREHOUSE_QUOTES.DOCUMENT_WAREHOUSE_QUOTE.replace(':id', id.toString()), {
            headers: { ...fetchDefaultHeaders }
        }).then((response) => {
            response.blob().then((blob) => {
                const a = document.createElement('a');
                const url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = `cotización warehouse n°${id}.docx`;
                a.click();
                window.URL.revokeObjectURL(url);
                if (changeAnimation)
                    changeAnimation('downloadSuccess', 'descarga exitosa', true);
            }).catch((error) => {
                if (changeAnimation) changeAnimation('error', 'descarga fallida', true);
            });
        })
        .catch((error) => {
            if (changeAnimation) changeAnimation('error', 'descarga fallida', true);
        });
    };
    return {
        createWarehouseQuote,
        storeWarehouseQuote,
        editWarehouseQuote,
        updateWarehouseQuote,
        showWarehouseQuote,
        deleteWarehouseQuote,
        getDocumentWarehouseQuote,
        fetchingCreate,
        fetchingStore,
        fetchingEdit,
        fetchingUpdate,
        fetchingShow,
        fetchingDelete
    };
};

export default useWarehouseQuoteService;
